import React from "react";

function SectionTitle({ title, className }) {
  return (
    <h2
      className={`text-[30px] md:text-[45px] laptop:text-[66px] font-bold leading-none laptop:leading-[66px] tracking-tighter laptop:-tracking-[2px] text-white text-center ${className}`}
    >
      {title}
    </h2>
  );
}

function SectionDetail({ detail, className }) {
  return (
    <p
      className={`text-sm md:text-base laptop:text-[20px] font-normal leading-5 md:leading-7 text-gray -tracking-04 ${className}`}
    >
      {detail}
    </p>
  );
}

export { SectionTitle, SectionDetail };
